export default __webpack_public_path__ + "static/media/bspring_main.b7576157.webp";